import React, { useContext } from "react";
import { Route, Switch, useParams } from "react-router-dom";
import { useSearchParam } from "react-use";
import { Provider } from "jotai";
import { CourseContext } from "../../Store";
import {
    questionnaireIdAtom,
    statusFilterAtom
} from "service/stores/Question/Students";
import Review from "../Review";
import IndexTable from "./IndexTable";
const Index = () => {
    const { basename } = useContext(CourseContext);
    const { questionnaireId } = useParams<{ questionnaireId: string }>();
    const status = useSearchParam("status") || "all"; // 默认过滤状态
    const exerciseBaseName = `${basename}/question/students/${questionnaireId}`;

    return (
        <Provider
            initialValues={
                [
                    [questionnaireIdAtom, questionnaireId],
                    [statusFilterAtom, status]
                ] as any
            }>
            <Switch>
                <Route
                    path={`${exerciseBaseName}/review/:studentNo`}
                    component={Review}
                />
                <Route component={IndexTable} />
            </Switch>
        </Provider>
    );
};

export default Index;
